/* eslint-disable import/prefer-default-export */
import * as ReduxHelpers from '@src/utils/reduxHelpers'
const prefix = 'cam/changes'

//Action Types
export const GET_CHANGES_LIST_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_CHANGES_LIST_SUCCESS'
)
export const GET_CHANGES_LIST_FAIL = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_CHANGES_LIST_FAIL'
)
export const REQUEST_PENDING = ReduxHelpers.Types.createActionType(
  prefix,
  'CHANGE_REQUEST_PENDING'
)
export const DISPOSE_CHANGES = ReduxHelpers.Types.createActionType(
  prefix,
  'DISPOSE_CHANGES'
)
export const SET_TAB = ReduxHelpers.Types.createActionType(prefix, 'SET_TAB')
export const SET_USE_CHANGES_PAGE_FLAG = ReduxHelpers.Types.createActionType(
  prefix,
  'SET_USE_CHANGES_PAGE_FLAG'
)
